import React from "react";
import { Chip, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LockIcon from "@mui/icons-material/Lock";
import { useTranslation } from "react-i18next";
import {
  EXERCISE_MODE_LABELS,
  AI_STATUS_COLORS,
  ASSISTANCE_TYPE_COLORS,
} from "../../theme/tokens";

// Pure display helpers derived from exercise fields already loaded by the
// caller (exercise.aiEnabled, exercise.mode, exercise.reviewStatus) — no
// data fetching here.

export function AiStatusChip({ aiEnabled, sx = {} }) {
  const { t } = useTranslation();
  const colors = aiEnabled ? AI_STATUS_COLORS.active : AI_STATUS_COLORS.inactive;
  return (
    <Chip
      size="small"
      label={aiEnabled ? t("مفعّل") : t("معطّل")}
      sx={{ bgcolor: colors.bg, color: colors.fg, ...sx }}
    />
  );
}

export function AssistanceTypeChip({ mode, sx = {} }) {
  const { t } = useTranslation();
  const colors = ASSISTANCE_TYPE_COLORS[mode] || ASSISTANCE_TYPE_COLORS.hints;
  return (
    <Chip
      size="small"
      label={t(EXERCISE_MODE_LABELS[mode] || EXERCISE_MODE_LABELS.hints)}
      sx={{ bgcolor: colors.bg, color: colors.fg, ...sx }}
    />
  );
}

export function VerificationLine({ reviewStatus, sx = {}, iconSx = {} }) {
  const { t } = useTranslation();
  const isValidated = reviewStatus === "validated";
  const Icon = isValidated ? CheckCircleIcon : LockIcon;
  return (
    <Typography
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        fontSize: 13,
        color: isValidated ? "#16a34a" : "#94a3b8",
        ...sx,
      }}
    >
      <Icon sx={{ fontSize: 16, ...iconSx }} />
      {isValidated ? t("تم التحقق من الأستاذ") : t("غير متاح بعد")}
    </Typography>
  );
}
